<template>
    <div class="clinical reveal" ref="circontents">        
        <div class="cases" >

            <div class="sectionTitle black fsTitle stLeft" >
              <span class="stLine reveal"></span>
              <splitter :content="localize(sectionData.title)"></splitter>
            </div>

<!--             <div style="border:solid 2px green;">
                {{sectionData.api_data}}
                {{clinical_cases_data}}
            </div>
 -->
            <div class="clinical_cases" v-if="sectionData.api_data">
                <ul>
                    <li :class="['ccPanel',index==curIndex ? 'active':'']" :style="'--index:'+index" v-for="(item,index) in sectionData.api_data" :key="'cc_'+index">
                        
                        <div class="ccTitle fsText" @click="showItem(index)">
                            <span>{{item.title}}</span>
                            <i class="fal fa-chevron-down" ></i>
                        </div>
                        <div class="ccContentWrap" :style="'--h:'+arrTextH[index]+'px'">
                            <div class="ccContent fsTextSmall" >
                                {{item.summary}}

                                <div class="ccLink">
                                    <a :href="getItemURL(index)" target="_blank" >
                                        <span>{{localize('@view_publication')}}</span>
                                        <i class="fal fa-chevron-right pl-s" ></i>
                                    </a>
                                </div>
                                
                            </div>                        
                        </div>
                    </li>
                </ul>
                
            </div>

        </div>
    </div>
</template>

<style scoped>
.clinical
{
    padding-bottom: 150px;
}
.section-title
{
    font-size: 40px;
    text-align: center;
    color: #fff;
    letter-spacing: 0px;
}
.clinical_cases
{
    clear: both;
    width: 60vw;
    margin: auto;
    padding-top: 200px;
}
.clinical_cases ul
{
    list-style: none;
}
.ccPanel
{
    border-bottom: solid 1px #e2e2e2;
    padding: 20px 0px;
}
.ccTitle
{
    font-weight: 600 !important;
    position: relative;
    cursor: pointer;
}
.ccTitle span
{
    width: calc(100% - 50px);
    display: block;
}


.ccPanel .ccTitle i 
{
    position: absolute;
    right: 10px;
    top: calc(50% - 8px);
    font-size: 16px;
    color: var(--blue-main);
    transform: rotate(0deg);
    transition: all ease 0.4s;
    transform-origin: center center;
}
.ccPanel.active .ccTitle i 
{
    transform: rotate(180deg);
}


.reveal .ccPanel
{
    opacity: 0;
    transform: translateY(20px);        
    transition: all 0.8s cubic-bezier(0.645, 0.045, 0.355, 1.000);
    transition-delay: calc(var(--index) * 0.3s);
}
.reveal.active .ccPanel
{
    transform: translateY(0px);
    opacity: 1;
}




.ccPanel .ccContentWrap
{
    clear: both;
    height: 0px;
    overflow: hidden;    
    transition: all ease 1s;
    transition-delay: 0s;
}
.ccPanel.active .ccContentWrap
{
    height:var(--h);
}

.ccContent
{
    padding-top: 20px;
}
.ccLink
{
    padding: 20px 0px;
    display: block;
}


    @media (max-width: 850px) { 
        .clinical_cases
        {
            width: 80vw;
            padding-top: 20px;
        }        
    }    

    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {
    }    

</style>

<script>
import { mapActions, mapState } from "vuex";
import sidepager from "@/views/com/sidepager.vue";
import splitter from "@/views/com/splitter.vue";
import { splitLines,isMobileScreen }         from "@/utils";

export default 
{
    components: { sidepager,splitter },
    data()
    {
        return{
            curIndex:-1,
            sectionProgress:0,
            arrTextH:[],
            secIndex:1,
            selectedIndex:0,
            elementTitle:'',
            elementDesc:'',            
            sizerTitle:'',
            sizerContent:'',
            maxTextHeight:0,
            intChanger:Object,
            isAutoChanging:false,
            styles:[]
        }
    },
    props:{
        sectionDataIndex:Number,
        sectionScrollProg:Object
    },
    mounted()
    {
        let vm = this;
        setTimeout(() => {
            //vm.collectHeights();
            vm.loadApiData();
        }, 500);
    },
    destroyed() {
        //this.removeImgScroller();
    },
    computed: {
        ...mapState(["clinical_cases_data","siteData","siteDataReady","siteVisibleSection"]),
        sectionData()
        {
            return this.siteData.SECTIONS[this.sectionDataIndex];
        }
    },
    watch: {
        //sectionScrollProg
        '$store.state.sectionScrollProg': function() {
            //alert("updatung");
            //alert(this.sectionDataIndex);
            //if(this.sectionScrollProg.index==this.sectionDataIndex)
            //{
                //this.updateStyles();
            //}
        },
      '$store.state.siteVisibleSection': function() {
        var vm=this;        
        let _siteVisibleSection = this.$store.state.siteVisibleSection;        
        if(_siteVisibleSection==this.sectionDataIndex+1){
            //alert("start auto timer");
            //start the timer
            if(isMobileScreen()==false){
                //vm.startAutoChange();
            }
        }else
        {
            //vm.stopAutoChange();
        }
      }
    },

    methods:
    {
        showItem(index)
        {
            if(this.curIndex==index){
                this.curIndex=-1;   
            }else{
                this.curIndex=index;   
            }            
            this.updatePanels();         
        },
        updatePanels()
        {
            var vm=this;
            vm.arrTextH = [];
            let items = vm.$el.querySelectorAll(".ccContent");
            for (var i = 0; i < items.length; i++) 
            {
                let br = items[i].getBoundingClientRect();
                vm.arrTextH.push(br.height);
            }
        },
        getItemURL(index)
        {
            //let itemData = this.clinical_cases_data[index];
            let itemData = this.sectionData.api_data[index];
            let itemURL = itemData.children[0].url;
            itemURL = itemURL.toLowerCase();
            if (itemURL.indexOf("http://") <0  && itemURL.indexOf("https://") < 0) {
                itemURL = "https://www.mis-implants.com/upload/"+itemURL;
            }

            return itemURL;
        },
        getTitleStyle(index)
        {
            if(this.styles.length>0){
                let cssData = this.styles[index];
                return 'opacity:'+cssData.alpha+";font-size:"+cssData.fontSize+"px";
            }
            return '';
        },
        getDescStyle(index)
        {
            if(this.styles.length>0){
                return 'height:'+this.styles[index].textH+'px';
            }
            return '';
        },        
        setText()
        {

            let elData = this.sectionData.items[this.selectedIndex];
            this.elementTitle = elData[0];
            this.elementDesc = elData[1];
        },
        setTextRectSize()
        {
            //This will find the heighest text rect size
            //and will apply to the text wrapper (this.$refs.visibleTextRect)
            //in order to avoid moving the pager below the text
            let rectElement = this.$refs.tempSizingRect; 
            let visibleRectElement = this.$refs.visibleTextRect;

            var rectsList = rectElement.querySelectorAll(".temprect");            
            for (var i = 0; i < rectsList.length; i++) 
            {
                let rectEl = rectsList[i];
                var rect = rectEl.getBoundingClientRect();
                console.log("rect item:"+i+" text height:"+rect.height); 
                if(rect.height>this.maxTextHeight){this.maxTextHeight = rect.height;}
            }
            rectElement.style.display="none";//hide the temp rect
            this.maxTextHeight = this.maxTextHeight + 10;
            visibleRectElement.style.height = this.maxTextHeight + "px";
        },
        scrollImg()
        {
            if(isMobileScreen()){
                //scroll on mobile version
                //let scrollToElement = this.$refs.bnImgScroll1.getElementsByClassName("bnImgItem")[this.selectedIndex];
                //scrollToElement.scrollIntoView({ behavior:'smooth',inline:'center',block:'nearest'});
            }else{
                //fade in/out relevent images on desktop version

            }

        }
    }
};
</script>

